<button class="btn-transparent btn_icon" [matMenuTriggerFor]="menu" type="button">
  <img class="icon" src="../../../../../../../assets/img/icons/ico_16_Menu.svg" alt="Menu">
</button>
<mat-menu #menu="matMenu">
  <button class="btn-transparent btn_icon" mat-menu-item *ngFor="let item of this.MenuItems" 
  (click)="RunMenu(item)" type="button">{{item?.name}}</button>
</mat-menu>